/**
 * @file utils/routing/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const APP_VERSION_PATH = "/version";
// calculated this way as createFeedCookie method multiplies expiry by 1000 days as seconds.
export const TWO_MINUTES_AS_1000_DAYS = 0.00138;

export const STATUS_CODE_SUCCESS = "SUCCESS";
